module.exports = __webpack_public_path__ + "static/media/envoyer-message.431d7746.png";